<script setup lang="ts">
import Button from "../../base-components/Button";
import UsuariosAgregar from "./components/UsuariosAgregar.vue";
import UsuariosAgregarClave from "./components/UsuariosAgregarClave.vue";
import UsuariosInvitacionesListado from "./components/UsuariosInvitacionesListado.vue";
import UsuariosListado from "./components/UsuariosListado.vue";
import { ref } from "vue";

const showFormAgregar = ref(false);
const showFormAgregarUsuarioClave = ref(false);
</script>

<template>
  <div v-if="!showFormAgregar && !showFormAgregarUsuarioClave" class="mt-5">
    <Button
      variant="primary"
      class="mb-2 mr-1"
      @click="
        () => {
          showFormAgregar = true;
        }
      "
    >
      Agregar usuario con mail (recomendado)
    </Button>
    <br />
    <Button
      variant="primary"
      class="mb-2 mr-1 mt-2"
      @click="
        () => {
          showFormAgregarUsuarioClave = true;
        }
      "
    >
      Agregar usuario con clave
    </Button>
  </div>
  <div v-else class="mt-5">
    <UsuariosAgregar
      v-if="showFormAgregar"
      @cerrar="
        () => {
          showFormAgregar = false;
        }
      "
    />
    <UsuariosAgregarClave
      v-if="showFormAgregarUsuarioClave"
      @cerrar="
        () => {
          showFormAgregarUsuarioClave = false;
        }
      "
    />
  </div>
  <UsuariosInvitacionesListado />
  <UsuariosListado />
</template>
